export * from "./employment";
export * from "./expo";
export * from "./interview.constants";

export const USER_TYPES = {
    PERSON: { text: "개인회원", value: "PERSON" },
    COMPANY: { text: "기업회원", value: "COMPANY" },
};

export const USER_LIKE_TYPES = {
    BLACKLISTED: { value: "BLACKLISTED", text: "블랙리스트" },
    USER_COMPNY: { value: "USER_COMPNY", text: "기업" },
    USER_PERSON: { value: "USER_PERSON", text: "지원자" },
    APPLICATION: { value: "APPLICATION", text: "지원서" },
    RECRUITMENT: { value: "RECRUITMENT", text: "채용공고" },
    EXPOPROGRAM: { value: "EXPOPROGRAM", text: "브릿지 프로그램" },
};

export const USER_SCOPE_TYPES = {
    CONSOLE: { text: "관리자", value: "console" },
};

export const FOOTER_SNS_TYPES = {
    twitter: { text: "트위터", value: "twitter" },
    facebook: { text: "페이스북", value: "facebook" },
    instagram: { text: "인스타그램", value: "instagram" },
};

export const USER_FILE_TYPES = {
    LOGO: { value: "LOGO", field: "_logo" },
    PROFILE: { value: "PROFILE", field: "_profile" },
    BUSINESS_REGISTRATION: { value: "BUSINESS_REGISTRATION", field: "_businessRegistration" },
};

export const RECRUITMENT_STATES = {
    ON_GOING: { value: "ON_GOING", text: "모집중" },
    FINISHED: { value: "FINISHED", text: "모집완료" },
    NO_SHOWN: { value: "NO_SHOWN", text: "미노출" },
    CANCELED: { value: "CANCELED", text: "취소" },
};

export const EDUCATION_INSTITUTION_TYPES = {
    HIGHSCHOOL: { value: "HIGHSCHOOL", text: "고등학교" },
    COLLEGE: { value: "COLLEGE", text: "대학(2-3년)" },
    UNIVERSITY: { value: "UNIVERSITY", text: "대학교(4년)" },
    MASTER: { value: "MASTER", text: "석사" },
    DOCTOR: { value: "DOCTOR", text: "박사" },
};

export const EDUCATION_ATTENDING_STATUSES = {
    ENROLLED: { value: "ENROLLED", text: "재학중" },
    GRADUATED: { value: "GRADUATED", text: "졸업" },
    GRADUATE_TO_BE: { value: "GRADUATE_TO_BE", text: "졸업예정" },
};

export const EDUCATION_LEVELS = {
    HIGHSCHOOL: { value: "HIGHSCHOOL", text: "고등학교 졸업" },
    COLLEGE: { value: "COLLEGE", text: "대학(2-3년) 졸업" },
    UNIVERSITY: { value: "UNIVERSITY", text: "대학교(4년) 졸업" },
    MASTER: { value: "MASTER", text: "석사 졸업" },
    DOCTOR: { value: "DOCTOR", text: "박사 졸업" },
};

export const EMPLOYMENT_TYPES = {
    REGULAR: { value: "REGULAR", text: "정규직" },
    CONTRACT: { value: "CONTRACT", text: "계약직" },
    // MILITARY_SERVICE: { value: "MILITARY_SERVICE", text: "병역특례" },
    INTERNSHIP: { value: "INTERNSHIP", text: "인턴" },
    // TEMP: { value: "TEMP", text: "파견직" },
    FREELANCER: { value: "FREELANCER", text: "전문프리랜서" },
    // ENTRUSTED: { value: "ENTRUSTED", text: "위촉직" },
    MANAGEMENT: { value: "MANAGEMENT", text: "운영인력" },
    // PART_TIME: { value: "PART_TIME", text: "알바" },
    // TRAINEE: { value: "TRAINEE", text: "교육생(연수생)" },
    // TIME_WAGER: { value: "TIME_WAGER", text: "시간제" },
    FOREIGNER: { value: "FOREIGNER", text: "외국인" },
    ASSISTANT: { value: "ASSISTANT", text: "사무보조" },
    OTHERS: { value: "OTHERS", text: "기타" },
};

export const WORK_EXPERIENCES = {
    NEW_RECRUIT: { value: "NEW_RECRUIT", text: "신입" },
    EXPERIENCED: { value: "EXPERIENCED", text: "경력" },
};

export const LANGUAGE_TYPES = {
    ENGLISH: { value: "ENGLISH", text: "영어" },
    JAPANESE: { value: "JAPANESE", text: "일본어" },
    CHINESE: { value: "CHINESE", text: "중국어" },
    ANOTHER: { value: "ANOTHER", text: "제2외국어" },
};

export const OFFICE_SKILL_TYPES = {
    MS_WORD: { value: "MS_WORD", text: "워드" },
    MS_PPTX: { value: "MS_PPTX", text: "파워포인트" },
    MS_EXCL: { value: "MS_EXCL", text: "엑셀" },
    HAN_GUL: { value: "HAN_GUL", text: "한글" },
    WEBSURF: { value: "WEBSURF", text: "인터넷" },
    ANOTHER: { value: "ANOTHER", text: "기타" },
};

export const GENDERS = {
    MALE: { value: "MALE", text: "남성" },
    FEMALE: { value: "FEMALE", text: "여성" },
};

export const WAGE_TYPES = {
    HOURLY: { value: "HOURLY", text: "시급" },
    DAILY: { value: "DAILY", text: "일급" },
    WEEKLY: { value: "WEEKLY", text: "주급" },
    MONTHLY: { value: "MONTHLY", text: "월급" },
    YEARLY: { value: "YEARLY", text: "연봉" },
    PER_CASE: { value: "PER_CASE", text: "건별" },
    REFERENCE_TO_VIEW_PAGE: { value: "REFERENCE_TO_VIEW_PAGE", text: "모집공고문 참조" },
    REFERENCE_TO_RULE_BOOK: { value: "REFERENCE_TO_RULE_BOOK", text: "회사내규에 따름" },
    REFERENCE_TO_INTERVIEW: { value: "REFERENCE_TO_INTERVIEW", text: "면접 후 결정" },
};

export const RECRUITMENT_QUESTION_TYPES = {
    SHORT_ANSWER: { value: "SHORT_ANSWER", text: "단답형" },
    DESCRIPTIVE: { value: "DESCRIPTIVE", text: "서술형" },
    MULTIPLE_CHOICE: { value: "MULTIPLE_CHOICE", text: "선다형" },
};

export const APPLICATION_STATES = {
    ON_WRITING: { value: "ON_WRITING", text: "작성중" },
    IS_APPLIED: { value: "IS_APPLIED", text: "지원완료" },
    IS_REVOKED: { value: "IS_REVOKED", text: "지원취소" },
    ON_RECRUIT: { value: "ON_RECRUIT", text: "합격" },
};

export const APPLICATION_WRITIG_STEPS = {
    RESUME: { value: "RESUME", text: "개인정보 입력" },
    MICEPEC_RECORDS: { value: "MICEPEC_RECORDS", text: "마이스펙 이력 확인" },
    QUESTIONS: { value: "QUESTIONS", text: "추가 질문답변" },
    COMPLETED: { value: "COMPLETED", text: "완료" },
};

export const APPLICATION_STAGES = {
    IS_APPLIED: { value: "IS_APPLIED", text: "지원완료" },
    ON_PENDING: { value: "ON_PENDING", text: "지원완료" },
    ON_MEETING: { value: "ON_MEETING", text: "지원완료" },
    ON_RECRUIT: { value: "ON_RECRUIT", text: "합격" },
    ELIMINATED: { value: "ELIMINATED", text: "지원완료" },
};

export const RECRUITMENT_KANBAN_FIELDS = {
    APPLIED: { value: "applied", text: "지원", color: "primary", stage: APPLICATION_STAGES.IS_APPLIED.value },
    PENDING: { value: "pending", text: "심사중", color: "yellow", stage: APPLICATION_STAGES.ON_PENDING.value },
    MEETING: { value: "meeting", text: "면접", color: "green", stage: APPLICATION_STAGES.ON_MEETING.value },
    RECRUIT: { value: "recruit", text: "합격", color: "secondary", stage: APPLICATION_STAGES.ON_RECRUIT.value },
    REMOVED: { value: "removed", text: "탈락", color: "grey", stage: APPLICATION_STAGES.ELIMINATED.value },
};

export const MEETING_STATES = {
    MATCHING_ON_GOING: { value: "MATCHING_ON_GOING", text: "매칭 진행중" },
    MATCHING_COMPLETE: { value: "MATCHING_COMPLETE", text: "매칭 완료" },
    MEETINGS_PROGRESS: { value: "MEETINGS_PROGRESS", text: "미팅 진행중" },
    MEETINGS_COMPLETE: { value: "MEETINGS_COMPLETE", text: "미팅 완료" },
};

export const MEETING_SCHEDULE_STATES = {
    AWAITING: { value: "AWAITING", text: "대기" },
    CANCELED: { value: "CANCELED", text: "취소" },
    APPROVED: { value: "APPROVED", text: "확정" },
};

export const RECRUITMENT_LIST_SORTS = {
    CREATED_AT_DESC: { value: "CREATED_AT_DESC", text: "최근게시순", sort: { createdAt: -1 } },
    HIT_COUNTS_DESC: { value: "HIT_COUNTS_DESC", text: "인기순", sort: { "meta.count.hit__m": -1, createdAt: -1 } },
    APPLICATION_ASC: { value: "APPLICATION_ASC", text: "마감임박순", sort: { "application.endsAt": 1 }, params: () => ({ "application.endsAt": [{ $gte: Date.now() }] }) },
};

export const FORM_STATES__POINT_ORDER_ACCOUNT = {
    PAYMENT_AWAITING: { value: "PAYMENT_AWAITING", text: "입금대기" },
    PAYMENT_COMPLETE: { value: "PAYMENT_COMPLETE", text: "입금완료" },
    PURCHASE_CANCELD: { value: "PURCHASE_CANCELD", text: "구매취소" },
};

export const FORM_STATES__SERVICE_INQUIRY = {
    ANSWER_AWAITING: { value: "ANSWER_AWAITING", text: "답변대기" },
    ANSWER_COMPLETE: { value: "ANSWER_COMPLETE", text: "답변완료" },
};

export const USER_POINT_ORDER_STATES = {
    UNPAID: { value: "UNPAID", text: "결제대기" },
    PAID: { value: "PAID", text: "결제완료" },
    CANCELED_PARTIALLY: { value: "CANCELED_PARTIALLY", text: "부분취소" },
    CANCELED_COMPLETELY: { value: "CANCELED_COMPLETELY", text: "구매취소" },
};
